export default "__VITE_ASSET__ZZr6gs$g__$_?url__"